import { t } from 'localization/utils/t';

const TP = 'shared.hooks.useGenderLabel';

export const getGenderLabel = (gender: string) => {
  const genderLabels = {
    men: t(`${TP}.menPossessive`, "Men's"),
    women: t(`${TP}.womenPossessive`, "Women's"),
    youth: t(`${TP}.youthPossessive`, 'Youth'),
    infant: t(`${TP}.infantPossessive`, 'Infant'),
  };

  return genderLabels?.[gender?.toLowerCase()] || gender;
};

export const useGenderLabel = () => getGenderLabel;
